import { render, staticRenderFns } from "./SchoolUserInfoList.vue?vue&type=template&id=44c650ec&scoped=true"
import script from "./SchoolUserInfoList.vue?vue&type=script&lang=js"
export * from "./SchoolUserInfoList.vue?vue&type=script&lang=js"
import style0 from "./SchoolUserInfoList.vue?vue&type=style&index=0&id=44c650ec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c650ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c650ec')) {
      api.createRecord('44c650ec', component.options)
    } else {
      api.reload('44c650ec', component.options)
    }
    module.hot.accept("./SchoolUserInfoList.vue?vue&type=template&id=44c650ec&scoped=true", function () {
      api.rerender('44c650ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolUserInfo/SchoolUserInfoList.vue"
export default component.exports